import React from "react";
import SingleContentPage from "../Shared/SingleContentPage";

const ChildCareCentre = () => {
  return <SingleContentPage title="Child Care Centre" moduleKey="child-care-centre" />;
};

export default ChildCareCentre;
